export const SELECTED_SHIPPING_STORAGE_KEY = "wireox_selected_shipping_method";
export const FEDEX_CARRIERS = ["fedex_walleted"];

export const SHIPPING_CUTOFF_METHODS = [
  {
    id: "flatrate5",
    name: "FedEx Standard Overnight",
    icon: "fedex",
    hours: 6,
    minutes: 4,
    seconds: 47,
    cutoffTime: "3:00 PM",
    default: true,
    type: "domestic",
    carriers: ["fedex_walleted"],
    serviceCode: "fedex_standard_overnight",
  },
  {
    id: "flatrate3",
    name: "FedEx Ground",
    icon: "fedex-ground",
    hours: 2,
    minutes: 15,
    seconds: 30,
    cutoffTime: "2:00 PM",
    type: "domestic",
    carriers: ["fedex_walleted"],
    serviceCode: "fedex_home_delivery",
  },
  {
    id: "flatrate4",
    name: "FedEx 2Day",
    icon: "fedex",
    hours: 8,
    minutes: 34,
    seconds: 47,
    cutoffTime: "4:00 PM",
    type: "domestic",
    carriers: ["fedex_walleted"],
    serviceCode: "fedex_2day",
  },
  {
    id: "flatrate6",
    name: "FedEx Priority Overnight",
    icon: "fedex",
    hours: 6,
    minutes: 4,
    seconds: 47,
    cutoffTime: "3:00 PM",
    type: "international",
    carriers: ["fedex_walleted"],
    serviceCode: "fedex_priority_overnight",
  },
  {
    id: "flatrate5-intl",
    name: "FedEx Standard Overnight",
    icon: "fedex",
    hours: 6,
    minutes: 4,
    seconds: 47,
    cutoffTime: "3:00 PM",
    type: "international",
    carriers: ["fedex_walleted"],
    serviceCode: "fedex_standard_overnight",
  },
];

export const DEFAULT_SHIPPING_METHOD_ID =
  SHIPPING_CUTOFF_METHODS.find((method) => method.default)?.id ||
  SHIPPING_CUTOFF_METHODS[0].id;

export const getSelectedShippingMethodId = () => {
  try {
    const stored = localStorage.getItem(SELECTED_SHIPPING_STORAGE_KEY);
    if (
      stored &&
      SHIPPING_CUTOFF_METHODS.some((method) => method.id === stored)
    ) {
      return stored;
    }
  } catch {
    // Ignore storage read errors.
  }
  return DEFAULT_SHIPPING_METHOD_ID;
};

export const getShippingMethodConfig = (methodId) => {
  return (
    SHIPPING_CUTOFF_METHODS.find((method) => method.id === methodId) ||
    SHIPPING_CUTOFF_METHODS.find((method) => method.default) ||
    SHIPPING_CUTOFF_METHODS[0]
  );
};

const matchesCutoffMethod = (rate, method) => {
  if (
    method.carriers?.length &&
    !method.carriers.includes(rate.CarrierCode)
  ) {
    return false;
  }

  if (method.serviceCode) {
    return rate.ServiceCode === method.serviceCode;
  }

  return true;
};

const pickCheapestRate = (rates) => {
  if (!rates.length) return null;
  return [...rates].sort(
    (a, b) => Number(a.TotalCost) - Number(b.TotalCost),
  )[0];
};

export const pickShippingRateForMethod = (rates, method) => {
  if (!Array.isArray(rates) || !method) return null;

  const matchingRates = rates.filter((rate) =>
    matchesCutoffMethod(rate, method),
  );

  return pickCheapestRate(matchingRates);
};

export const notifyShippingMethodChanged = (methodId) => {
  window.dispatchEvent(
    new CustomEvent("shippingMethodChanged", { detail: methodId }),
  );
};
